import React from 'react';
import {
  Box,
  Button,
  Checkbox,
  FilledInput,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from '@material-ui/core';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import style from './formik.module.css';
import { useDispatch } from 'react-redux';
import {
  createTeenybeansSchoolAsync,
  createTeenybeansUserAsync,
} from './bccTeenybeansStore/bccTeenybeansStoreSlice';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useState } from 'react';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { sendMessageAsync } from '../../common/CommonStore/CommonStoreSlice';

const currentDate = new Date().toISOString().split('T')[0];

const initialValues = {
  name: '',
  email: '',
  phone: '',
  expiryDate: currentDate,
  // agreementDocuments: [
  //   {
  //     docS3Key: '',
  //     title: '',
  //     description: '',
  //   },
  // ],
};

function AddSchool() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [username, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [moduleAccess, setModuleAccess] = useState({
    DASHBOARD: false,
    DIGITAL_DELIVERABLES: false,
    METHODOLOGY_TRAINING: false,
    ROI: false,
    SCHOOL_DOCUMENTS: false,
    TEAMS: false,
    AKADMY: false,
    WEBSITE_BUILDER: false,
  });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // const handleUploadDocument = (e, index, setFieldValue) => {
  //   dispatch(uploadFileAsync({ file: e.target.files[0] }))
  //     .unwrap()
  //     .then((res) => {
  //       setFieldValue(
  //         `agreementDocuments.${index}.docS3Key`,
  //         res && res.data && res.data.document
  //       );
  //     });
  // };
  //

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <Box border="1px solid #dfdfdf" p={3}>
            <Box mb={3} fontSize={22} fontWeight={'fontWeightSmall'}>
              School details
            </Box>
            <Formik
              initialValues={initialValues}
              onSubmit={async (values) => {
                await new Promise((r) => setTimeout(r, 500));

                const payload = {
                  ...values,
                  phone: `+91-${values.phone}`,
                  isActive: false,
                  moduleAccess: moduleAccess,
                };
                if (phone.match(/^\d{10}$/) && values.phone.match(/^\d{10}$/)) {
                  if (password.length >= 8) {
                    dispatch(createTeenybeansSchoolAsync(payload))
                      .unwrap()
                      .then((res) => {
                        if (res && res.data && res.data._id !== '') {
                          dispatch(
                            createTeenybeansUserAsync({
                              name: username,
                              role: 'ADMIN',
                              mobile: phone,
                              password: password,
                              email: email,
                              schoolId: res.data._id,
                            })
                          )
                            .unwrap()
                            .then((res) => {
                              toast.success(
                                'School and User Created Successfully'
                              );
                              sendWelcomeMail(email);
                              function sendWelcomeMail(userMailId) {
                                // ---------Mail sent-----------------
                                let formData = new FormData();
                                formData.append('sendMail', 'true');
                                formData.append('reciever', userMailId);
                                formData.append('sender', 'Teeny Beans');
                                formData.append(
                                  'senderMail',
                                  'no-reply@teenybeans.in'
                                );
                                formData.append(
                                  'subject',
                                  'You have been invited to Teeny Beans Partner Portal!'
                                );
                                formData.append(
                                  'message',
                                  `<html>
      <body style="background-color:#f5f8f5;padding:16px;">
                          <div style="text-align:center">
                            <a href="#"><img width="150px" src="https://teenybeans.in/assets/tb-logo1.png"></a>
                          </div>
                          <div style="padding-top:16px;">Hi ${username},</div><br/>
                          <div style="padding-top:16px;">You have been invited by "Rohit Singh" to join Teeny Beans's account on the partner portal!</div>
                          <div style="padding-top:16px;">Use the following credentials to log into to partner portal account:</div>
                          <div style="padding-top:16px;">URL: <a href="https://portal.teenybeans.in/" target="_blank">https://portal.teenybeans.in/</a></div>
                          <div style="padding-top:2px;">Username: ${email}</div>
                          <div style="padding-top:2px;">password: ${password}</div>
                          <div style="padding-top:16px;">Regards,<br/>Team Teeny Beans</div>
      </body>
      <html>
      `
                                );
                                fetch('https://mailapi.teenybeans.in/009/', {
                                  method: 'POST',
                                  body: formData,
                                })
                                  .then(function (response) {
                                    response.json().then(function (data) {});
                                  })
                                  .catch(function (err) {
                                    // console.log('Fetch Error :-S', err)
                                  });
                              }
                              history.push('/teenybeans-portal');
                            })
                            .catch((err) => {
                              toast.error(
                                'Something went wrong, user not created'
                              );
                            });
                        }
                      })
                      .catch((err) => {
                        toast.error(err.message);
                      });
                  } else {
                    toast.error('Password is Greater than 7 character');
                  }
                } else {
                  toast.error('Enter 10 digit phone number');
                }
              }}
              // validate={(values) => {
              //   const errors = {};
              //   values.agreementDocuments.forEach((field, index) => {
              //     if (
              //       field.docS3Key === '' ||
              //       field.title === '' ||
              //       field.description === ''
              //     ) {
              //       errors[`agreementDocuments${index}`] = 'Field is required';
              //     }
              //     setErrCheck(field);
              //   });
              //   return errors;
              // }}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <label>School name</label>
                      <Field
                        className={style.field}
                        type="text"
                        id="name"
                        name="name"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <label>Phone</label>
                      <Field
                        className={style.field}
                        type="tel"
                        // id="phone"
                        name="phone"
                      />
                      <ErrorMessage name="phone" component="div" />
                    </Grid>
                    <Grid item xs={6}>
                      <label>Email</label>
                      <Field
                        className={style.field}
                        type="email"
                        id="email"
                        name="email"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <label>Expiry date</label>
                      <Field
                        className={style.field}
                        type="date"
                        id="expiryDate"
                        name="expiryDate"
                        min={currentDate}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <label>Manage access</label>
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={moduleAccess.DASHBOARD}
                            onChange={(e) =>
                              setModuleAccess({
                                DASHBOARD: e.target.checked,
                                DIGITAL_DELIVERABLES:
                                  moduleAccess.DIGITAL_DELIVERABLES,
                                METHODOLOGY_TRAINING:
                                  moduleAccess.METHODOLOGY_TRAINING,
                                ROI: moduleAccess.ROI,
                                SCHOOL_DOCUMENTS: moduleAccess.SCHOOL_DOCUMENTS,
                                TEAMS: moduleAccess.TEAMS,
                                AKADMY: moduleAccess.AKADMY,
                                WEBSITE_BUILDER: moduleAccess.WEBSITE_BUILDER,
                              })
                            }
                            name="Dashboard"
                            color="primary"
                          />
                        }
                        label="Dashboard"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={moduleAccess.DIGITAL_DELIVERABLES}
                            onChange={(e) =>
                              setModuleAccess({
                                DASHBOARD: moduleAccess.DASHBOARD,
                                DIGITAL_DELIVERABLES: e.target.checked,
                                METHODOLOGY_TRAINING:
                                  moduleAccess.METHODOLOGY_TRAINING,
                                ROI: moduleAccess.ROI,
                                SCHOOL_DOCUMENTS: moduleAccess.SCHOOL_DOCUMENTS,
                                TEAMS: moduleAccess.TEAMS,
                                AKADMY: moduleAccess.AKADMY,
                                WEBSITE_BUILDER: moduleAccess.WEBSITE_BUILDER,
                              })
                            }
                            name="Digital Delivarables"
                            color="primary"
                          />
                        }
                        label="Digital Delivarables"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={moduleAccess.METHODOLOGY_TRAINING}
                            onChange={(e) =>
                              setModuleAccess({
                                DASHBOARD: moduleAccess.DASHBOARD,
                                DIGITAL_DELIVERABLES:
                                  moduleAccess.DIGITAL_DELIVERABLES,
                                METHODOLOGY_TRAINING: e.target.checked,
                                ROI: moduleAccess.ROI,
                                SCHOOL_DOCUMENTS: moduleAccess.SCHOOL_DOCUMENTS,
                                TEAMS: moduleAccess.TEAMS,
                                AKADMY: moduleAccess.AKADMY,
                                WEBSITE_BUILDER: moduleAccess.WEBSITE_BUILDER,
                              })
                            }
                            name="Methodology Training"
                            color="primary"
                          />
                        }
                        label="Methodology Training"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={moduleAccess.ROI}
                            onChange={(e) =>
                              setModuleAccess({
                                DASHBOARD: moduleAccess.DASHBOARD,
                                DIGITAL_DELIVERABLES:
                                  moduleAccess.DIGITAL_DELIVERABLES,
                                METHODOLOGY_TRAINING:
                                  moduleAccess.METHODOLOGY_TRAINING,
                                ROI: e.target.checked,
                                SCHOOL_DOCUMENTS: moduleAccess.SCHOOL_DOCUMENTS,
                                TEAMS: moduleAccess.TEAMS,
                                AKADMY: moduleAccess.AKADMY,
                                WEBSITE_BUILDER: moduleAccess.WEBSITE_BUILDER,
                              })
                            }
                            name="ROI"
                            color="primary"
                          />
                        }
                        label="ROI"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={moduleAccess.SCHOOL_DOCUMENTS}
                            onChange={(e) =>
                              setModuleAccess({
                                DASHBOARD: moduleAccess.DASHBOARD,
                                DIGITAL_DELIVERABLES:
                                  moduleAccess.DIGITAL_DELIVERABLES,
                                METHODOLOGY_TRAINING:
                                  moduleAccess.METHODOLOGY_TRAINING,
                                ROI: moduleAccess.ROI,
                                SCHOOL_DOCUMENTS: e.target.checked,
                                TEAMS: moduleAccess.TEAMS,
                                AKADMY: moduleAccess.AKADMY,
                                WEBSITE_BUILDER: moduleAccess.WEBSITE_BUILDER,
                              })
                            }
                            name="School Document"
                            color="primary"
                          />
                        }
                        label="School Document"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={moduleAccess.TEAMS}
                            onChange={(e) =>
                              setModuleAccess({
                                DASHBOARD: moduleAccess.DASHBOARD,
                                DIGITAL_DELIVERABLES:
                                  moduleAccess.DIGITAL_DELIVERABLES,
                                METHODOLOGY_TRAINING:
                                  moduleAccess.METHODOLOGY_TRAINING,
                                ROI: moduleAccess.ROI,
                                SCHOOL_DOCUMENTS: moduleAccess.SCHOOL_DOCUMENTS,
                                TEAMS: e.target.checked,
                                AKADMY: moduleAccess.AKADMY,
                                WEBSITE_BUILDER: moduleAccess.WEBSITE_BUILDER,
                              })
                            }
                            name="Teams"
                            color="primary"
                          />
                        }
                        label="Teams"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={moduleAccess.AKADMY}
                            onChange={(e) =>
                              setModuleAccess({
                                DASHBOARD: moduleAccess.DASHBOARD,
                                DIGITAL_DELIVERABLES:
                                  moduleAccess.DIGITAL_DELIVERABLES,
                                METHODOLOGY_TRAINING:
                                  moduleAccess.METHODOLOGY_TRAINING,
                                ROI: moduleAccess.ROI,
                                SCHOOL_DOCUMENTS: moduleAccess.SCHOOL_DOCUMENTS,
                                TEAMS: moduleAccess.TEAMS,
                                AKADMY: e.target.checked,
                                WEBSITE_BUILDER: moduleAccess.WEBSITE_BUILDER,
                              })
                            }
                            name="Akadmy"
                            color="primary"
                          />
                        }
                        label="Akadmy"
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={moduleAccess.WEBSITE_BUILDER}
                            onChange={(e) =>
                              setModuleAccess({
                                DASHBOARD: moduleAccess.DASHBOARD,
                                DIGITAL_DELIVERABLES:
                                  moduleAccess.DIGITAL_DELIVERABLES,
                                METHODOLOGY_TRAINING:
                                  moduleAccess.METHODOLOGY_TRAINING,
                                ROI: moduleAccess.ROI,
                                SCHOOL_DOCUMENTS: moduleAccess.SCHOOL_DOCUMENTS,
                                TEAMS: moduleAccess.TEAMS,
                                AKADMY: moduleAccess.AKADMY,
                                WEBSITE_BUILDER: e.target.checked,
                              })
                            }
                            name="Website Builder"
                            color="primary"
                          />
                        }
                        label="Website Builder"
                      />
                    </Grid>
                  </Grid>

                  {/* <FieldArray name="agreementDocuments">
                    {({ insert, remove, push }) => (
                      <>
                        {values.agreementDocuments.length > 0 &&
                          values.agreementDocuments.map((document, index) => (
                            <div className="row" key={index}>
                              <Box
                                sx={{ borderTop: '2px dashed #dfdfdf', my: 2 }}
                              />
                              <Grid container spacing={2}>
                                <Grid item xs={6}>
                                  <label
                                    htmlFor={`agreementDocuments.${index}.title`}>
                                    Agreement Title
                                  </label>
                                  <Field
                                    className={style.field}
                                    name={`agreementDocuments.${index}.title`}
                                    type="text"
                                  />
                                  <ErrorMessage
                                    name={`agreementDocuments${index}`}
                                    component="div"
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <label
                                    htmlFor={`agreementDocuments.${index}.description`}>
                                    Agreement Description
                                  </label>
                                  <Field
                                    className={style.field}
                                    name={`agreementDocuments.${index}.description`}
                                    type="text"
                                  />
                                  <ErrorMessage
                                    name={`agreementDocuments${index}`}
                                    component="div"
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <label
                                    htmlFor={`agreementDocuments.${index}.uploadDocument`}>
                                    Upload Agreement Document
                                  </label>
                                  <input
                                    name={`agreementDocuments.${index}.uploadDocument`}
                                    className={style.field}
                                    type={'file'}
                                    onChange={(e) =>
                                      handleUploadDocument(
                                        e,
                                        index,
                                        setFieldValue
                                      )
                                    }
                                  />
                                  <ErrorMessage
                                    name={`agreementDocuments${index}`}
                                    component="div"
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <Box mt={3.4}>
                                    {index === 0 ? null : (
                                      <Button
                                        type="button"
                                        variant="outlined"
                                        className="secondary"
                                        onClick={() => remove(index)}>
                                        Remove
                                      </Button>
                                    )}
                                    &nbsp;&nbsp;
                                    <Button
                                      type="button"
                                      variant="contained"
                                      className="secondary"
                                      onClick={() =>
                                        push({
                                          docS3Key: '',
                                          title: '',
                                          description: '',
                                        })
                                      }>
                                      Add Documents
                                    </Button>
                                  </Box>
                                </Grid>
                              </Grid>
                            </div>
                          ))}
                      </>
                    )}
                  </FieldArray> */}
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Button
                        disabled={
                          values.name === '' ||
                          values.email === '' ||
                          values.phone === '' ||
                          values.expiryDate === '' ||
                          email === '' ||
                          username === '' ||
                          password === '' ||
                          phone === ''
                          // errCheck.title === '' ||
                          // errCheck.description === '' ||
                          // errCheck.docS3Key === ''
                        }
                        variant="contained"
                        color="primary"
                        type="submit">
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box border="1px solid #dfdfdf" p={0.4}>
            <Box bgcolor="#FFF6F2" fontSize={18} fontWeight={500} p={2}>
              Owner details
            </Box>
            <Box p={2}>
              <label>User name</label>
              <TextField
                value={username}
                onChange={(e) => setUserName(e.target.value)}
                size="small"
                variant="outlined"
                fullWidth
              />
              <Box mt={1.6} />
              <label>Email</label>
              <TextField
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                size="small"
                variant="outlined"
                fullWidth
              />
              <Box mt={1.6} />
              <label>Password</label>
              <FormControl fullWidth variant="outlined" size="small">
                <FilledInput
                  id="filled-adornment-password"
                  type={showPassword ? 'text' : 'password'}
                  onChange={(e) => setPassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <Box mt={1.6} />
              <label>Phone</label>
              <TextField
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                size="small"
                variant="outlined"
                fullWidth
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AddSchool;
